import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  HomeEduCenter,
  RiskTypeLinks,
  SolutionsList,
  Link,
} from '../../components'
import Styles from './EduCenterPlanAdmins.css'


@CSSModules(Styles, {allowMultiple:true})
export default class EduCenterPlanAdmins extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'If you\'re a company 401(k) plan administrator',
      description: 'Resources for administrators of employer-offered retirement plans to take action to make their plan more sustainable.',
      url: config.domain + config.routes.eduCenterPlanAdmins
    }
  }

  render() {
    const img1 = require( '../../../static/images/millenial_employees.jpg' )
    //
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <div styleName='small-page-title'>
            {this.state.title}
          </div>
          <div styleName='copy'>
            <h2>
              What are the company benefits of making a 401(k) plan more sustainable?
            </h2>
            <h3>
              Attract top talent and spur engagement
            </h3>
            <p>
              As millennial-aged employees now represent the majority of the U.S. workforce, it is increasingly important that management finds ways to engage them in the company. <Link to='https://www.morganstanley.com/pub/content/dam/msdotcom/ideas/sustainable-signals/pdf/Sustainable_Signals_Whitepaper.pdf' title='Sustainable Signals: New Data from the Individual Investor - Morgan Stanley' xstrong>A recent Morgan Stanley study found</Link> that 90% of millennials want sustainable investments as an option within their 401(k) plans. The study also found that 75% of millennials believe that their investments can influence climate change, and 84% believe that their investments have the power to help lift people out of poverty. Providing employees with the investment options which connect to their core values – like solving human, social and environmental problems through their work and investments – can attract top talent to companies and spur employee engagement.
            </p>
            <h3>
              Increase employee retention and company buy-in
            </h3>
            <p>
              Creating an environment where employees feel empowered to contribute to the greater good has been proven to increase employee retention and company buy-in. In fact, 67% of millennials would be more likely to contribute, or increase their plan contributions, <Link to='https://www.nytimes.com/2019/09/27/business/esg-401k-investing-retirement.html' title='Bit by Bit, Socially Conscious Investors Are Influencing 401(k)’s - New York Times' xstrong>if they knew their investments were contributing to social good.</Link>
            </p>
            <div styleName='img-blockquote'>
              <img
                src={img1}
                alt='90% of millennials want sustainable investments as an option within their 401(k) plans, and 75% of millennials believe that their investments can influence climate change.'
              />
              <blockquote>
                90% of millennials want sustainable investments as an option within their 401(k) plans, and 75% of millennials believe that their investments can influence climate change.
              </blockquote>
            </div>
            <h3>
              Align with corporate sustainability commitments
            </h3>
            <p>
              Companies are making increasingly bold commitments to decarbonization and prioritizing environmental and social sustainability in company operations and hiring. But if the retirement plan is investing employee savings unsustainably, this is a contradiction to those company commitments. As investors and stakeholders call for more action on climate change and social justice, this contradiction could become a reputational risk for the company.
            </p>
            <h3>
              Become an industry leader
            </h3>
            <p>
              As the demand for ESG investing continues to rise in popularity, employees across the country are discovering their power to align their values with their retirement plans investments. A bright light is now shining on retirement investments that have been hidden for over a century. Companies now have the opportunity to become leaders in the movement and demonstrate their support for the transition to an economy that is based on justice and sustainability
            </p>
            <h2>
              What are the solutions?
            </h2>
            <SolutionsList/>
            <h2>
              Plan administrator FAQs
            </h2>
            <h3>
              Is offering ESG funds in a defined contribution plan allowed under DOL rules?
            </h3>
            <p>
              While demand across the world for ESG investments has seen a dramatic spike in recent years, in 2020 the Trump Administration’s DOL (Department of Labor) attempted to constrain this growth by issuing a new rule which aims to limit how ESG investments can be considered in retirement plans. After hearing from labor organizations and asset managers across the country, the Biden Administration’s DOL stated they will revisit the rule, and until then, <Link to='https://www.cnbc.com/2021/03/11/biden-admin-making-it-easier-to-invest-in-esg-funds-in-401k-plans.html' title='The Department of Labor is making it easier to invest in ESG funds in your 401(k)' xstrong>will not be enforcing it.</Link>
            </p>
            <h3>
              Our plan has a self-directed option where employees can access thousands of different funds, including sustainable investments. Is this enough?
            </h3>
            <p>
              A self-directed option (also called a "brokerage window") can provide more access to sustainable funds. But a self-directed option requires more work from plan participants, and could lead to riskier investments. They’re also seldom used, with <Link to='https://www.investmentnews.com/brokerage-windows-401k-dol-208416' title='Seldom-used 401(k) brokerage windows being reviewed by DOL - Investment News' xstrong>approximately 2.4% of participants</Link> in large and medium-sized 401(k)s using brokerage windows. It's better for a retirement plan to offer access to sustainable funds without making people use a self-directed option - or even better, to make the default investment a sustainable fund.
            </p>
            <h3>
              What if our asset manager does not have any ESG options available?
            </h3>
            <p>
              Currently, an estimated $20 trillion AUM, <Link to='https://www.bloomberg.com/professional/blog/esg-assets-may-hit-53-trillion-by-2025-a-third-of-global-aum/' title='ESG assets may hit $53 trillion by 2025, a third of global AUM - Bloomberg' xstrong>or about a quarter of all actively managed funds,</Link> are incorporating ESG into portfolio construction in some way. If your asset manager does not have any appropriate ESG funds, or is not willing to provide them to your company, it may be time to find one that does.
            </p>
            <h3>
              We’re ready to make our employee retirement plan sustainability. Are there resources to help us?
            </h3>
            <p>
              Yes! A great resource for companies seeking to make their retirement plan sustainable is the Forum for Sustainable and Responsible Investment (US-SIF). US-SIF has a <Link to='https://www.ussif.org/education' title='Center for Sustainable Investment Education' xstrong>Center for Sustainable Investment Education</Link> with online and live courses, research publications, and more.
            </p>
          </div>
        </ContainerDivs>
        <RiskTypeLinks/>
        <HomeEduCenter/>
      </div>
    )
  }
}
